import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Container, Modal } from "react-bootstrap";
import "../css/BannerSection.css";
import { fha203kProgramName, foreignNationalProgramName, isFha } from '../Utils/WHL/helpers';
import BrokerForm from './BrokerForm';
// import PopupPatch from './popupPatch/PopupPatch';
import { setDeviceType } from "../store/actions/index";
import FormAcknowledgement from './FormAcknowledgement';
import FhaFormAcknowledgement from './FhaFormAcknowledgement';
import FHABrokerForm from './FHABrokerForm';
// import { propTypes } from 'react-bootstrap/esm/Image';
import { UserSession } from '../modules/UserSession';
import TestimonialCarousel from './TestimonialCarousel/TestimonialCarousel';
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu/index";


const FhaOnlyMarquee = (props) => {

    return (
        <div className="marquee">
            <p onClick={props.onClick}>0% Down FHA Loan Programs Available Now. <a onClick={() => { console.log('clicked') }}>Click Here</a> For Details.</p>

        </div>
    )
}


const SectionBelowTitle = ({
    pageDetails,
    screen
}) => {

    const { pageName, programDetails } = pageDetails

    return <>
        <div className="fs-2">
            {pageName === "Conventional" ? (
                <>
                    {" "}
                    {/* <OverlayTrigger
                        trigger="hover"
                        placement="bottom"
                        overlay={popover}
                    >
                        <h4 className="style3 mb-0 fs-1dot5">
                            No Underwriting Fee For Most Purchase Transactions{" "}
                        </h4>
                    </OverlayTrigger> */}
                    <h4 className="style4 fs-1dot5">Close before COE</h4>
                </>
            ) : (
                <>
                    <h3 className='' // fs-2
                        dangerouslySetInnerHTML={{
                            __html: programDetails.statement,
                        }}
                    ></h3>
                    {
                        pageName === "Prime Jumbo" && <>
                            <h5 className="style4 fs-1dot4">
                                Close your Purchase Transactions Before COE
                            </h5>
                        </>
                    }
                    {
                        pageName === "HECM" && <>
                            <h3 className="style3">
                                No Underwriting Fee!
                            </h3>
                            <h5 className="style4 mb-0">
                                Close your Purchase Transactions Before COE
                            </h5>
                        </>
                    }
                    {!(pageName === "HECM" || pageName === "Non QM" || pageName === "DSCR" ||
                        pageName === "Prime Jumbo" ||
                        pageName === foreignNationalProgramName
                    ) && <h4 className="style4 fs-1dot5">
                            Close your Purchase Transactions Before COE
                        </h4>}
                </>
            )}
        </div>
        {pageName === "Conventional" && (
            <div xs={12} sm={10} className="style5 fs-1 mt-2">
                <h6 className="mb-0">
                    <ul>
                        <li>Fast, Accurate, and comes with our exclusive 100% trusted  warranty*</li>
                        <li>Credit Score Down to 620</li>
                        <li>LTV Up To 97%</li>
                        <li>Primary Residence, Second Home & <div style={{
                            display: 'inline-block'
                        }}>
                            Investment Property Allowed</div></li>
                        <li>Appraisal Waiver as per AUS</li>
                        <li>DTI allowed Up To 50%</li>
                    </ul>
                </h6>
                {/* <p>*Visit <a href="https://www.swmc.com/disclaimer" target='_blank'>swmc.com/disclaimer</a> for terms and limitations of the 100% Trusted Warranty.</p>  */}
                <div className="space desktop-shown" />
            </div>
        )}
        {pageName === "VA" && (
            <div className="style5 fs-1 mt-2">
                <h6 className="mb-0">
                    <ul>
                        <li>Fast, Accurate, and comes with our exclusive 100% trusted  warranty*</li>
                        <li>100% Financing i.e. Zero Down Payment from Borrower</li>
                        <li>Owner-occupied Property</li>
                        <li>No Mortgage Insurance</li>
                        <li>Manufactured Homes Acceptable</li>
                        <li>DTI can exceed 55% subject to AUS Approval</li>
                    </ul>
                </h6>
                {/* <p>*Visit <a href="https://www.swmc.com/disclaimer" target='_blank'>swmc.com/disclaimer</a> for terms and limitations of the 100% Trusted Warranty.</p> */}
                <div className="space" />
            </div>
        )}
        {pageName === "FHA" && (
            <div className="style5 fs-1 mt-2">
                <h6 className="mb-0">
                    <ul>
                        <li>Fast, Accurate, and comes with our exclusive 100% trusted  warranty*</li>
                        <li>Minimum FICO 500</li>
                        <li>LTV upto 96.5%</li>
                        <li>Owner-occupied Property</li>
                        <li>Manufactured Homes Acceptable</li>
                        <li>Manual Underwriting Allowed</li>
                    </ul>
                </h6>
                {/* <p>*Visit <a href="https://www.swmc.com/disclaimer" target='_blank'>swmc.com/disclaimer</a> for terms and limitations of the 100% Trusted Warranty.</p> */}
                <div className="space" />
            </div>
        )}
        {pageName === "USDA" && (
            <div className="style5 fs-1 mt-2">
                <h6 className="mb-0">
                    <ul>
                        <li>Fast, Accurate, and comes with our exclusive 100% trusted  warranty*</li>
                        <li>100% Financing i.e. Zero Down Payment from Borrower</li>
                        <li>Owner-occupied Property</li>
                        <li>Manufactured Homes Acceptable</li>
                        <li>Property must be located in eligible rural area</li>
                        <li>Must meet USDA's income criteria</li>
                    </ul>
                </h6>
                {/* <p>*Visit <a href="https://www.swmc.com/disclaimer" target='_blank'>swmc.com/disclaimer</a> for terms and limitations of the 100% Trusted Warranty.</p> */}
                <div className="space" />
            </div>
        )}
        {
            pageName === 'Non QM' && (
                <>
                    <div className="style5 fs-1 mt-2">
                        <h6 className="mb-0">
                            <ul>
                                <li>Fast, accurate, and comes with our exclusive 100% trusted  warranty*</li>
                                <li>Manual Underwriting</li>
                                <li>In-House and Quick Underwriting</li>
                                <li>Purchase, Rate and Term, and Cash-Out Options Available</li>
                                <li>Primary Residence, Second Home, and Investment Property Allowed</li>
                                <li>Non-Permanent Resident also eligible</li>
                                <li>Second Appraisal not required up to $1.5M loan amount**</li>
                            </ul>
                        </h6>
                        {/* <p>
                            *Visit{" "}
                            <a href="https://www.swmc.com/disclaimer" target="_blank" style={{ color: "#fff" }}>
                                swmc.com/disclaimer
                            </a>{" "}
                            for terms and limitations of the 100% Trusted Warranty.
                        </p>
                        <p>
                            **For EZ DSCR (Debt Service Credit Ratio) Program, 2<sup>nd</sup>{" "}
                            full appraisal is required if Collateral Desktop Analysis (CDA)
                            variance is {">"} 10%, and for Individual Tax Identification
                            Number (ITIN) program 2<sup>nd</sup> appraisal required in case of
                            Flip transaction.
                        </p> */}
                    </div>
                </>
            )
        }
        {pageName === "HECM" && (
            <div className="style5 fs-2dot5 mt-2">
                <h6 className="mb-0">
                    <ul className="hecm-ul">
                        <li>Fast, Accurate, and comes with our exclusive 100% trusted  warranty*</li>
                        <li>Available to homeowners aged 62 or older
                            {screen === 'desktop' && <br></br>}
                            <span> (spouse can be younger)</span>
                        </li>
                        <li>No Monthly Mortgage Payment</li>
                        <li>Borrower must occupy the property as a primary residence</li>
                        <li>Eligible for Purchase or Refinance</li>
                        <li>Borrower retains title and possession of the property</li>
                    </ul>
                </h6>
                {/* <p>*Visit <a href="https://www.swmc.com/disclaimer" target='_blank'>swmc.com/disclaimer</a> for terms and limitations of the 100% Trusted Warranty.</p> */}

                <div className="space" />
            </div>
        )}
        {pageName === "Prime Jumbo" && (
            <div xs={12} sm={10} className="style5 fs-1 mt-2">
                <h6 className="mb-0">
                    <ul>
                        <li>Fast, Accurate, and comes with our exclusive 100% trusted  warranty*</li>
                        <li>Loan amounts up to $3M</li>
                        <li>FICO down to 680</li>
                        {/* <li>LTV up to 90% <div className="lg-inline-block">(100% for Medical Professional Program)</div></li> */}
                        <li>LTV up to 85%</li>
                        <li>DTI up to 49.99%</li>
                        <li>No Mortgage Insurance</li>
                        <li>Purchase and Refinance</li>
                        <li>All Occupancy Types OK</li>
                        <li>Fixed and Adjustable Rate option available</li>
                    </ul>
                </h6>
                {/* <p>*Visit <a href="https://www.swmc.com/disclaimer" target='_blank'>swmc.com/disclaimer</a> for terms and limitations of the 100% Trusted Warranty.</p> */}

                <div className="space desktop-shown" />
            </div>
        )}
        {pageName === "DSCR" && (
            <div xs={12} sm={10} className="style5 fs-1 mt-2">
                <h6 className="mb-0">
                    <ul>
                        <li>Fast, Accurate, and comes with our exclusive 100% trusted  warranty*</li>
                        <li>Loan amounts up to $3 million</li>
                        <li>Investment Property – Business Purpose Only</li>
                        <li>No DTI requirements</li>
                        <li>Min FICO 660</li>
                        <li>Max LTV 75%</li>
                        <li>Interest-Only option available</li>
                        <li>Debt Service Coverage Ratio (DSCR) must be <div className="lg-inline-block" style={{
                            display: 'inline-block'
                        }}>{'=>'} 1</div></li>
                        <li>No personal income is required</li>
                        <li>Limited Liability Corporation, S-Corporation, Partnership Eligible</li>
                        <li>Foreign National Borrowers Allowed</li>
                    </ul>
                </h6>
                {/* <p>*Visit <a href="https://www.swmc.com/disclaimer" target='_blank'>swmc.com/disclaimer</a> for terms and limitations of the 100% Trusted Warranty.</p> */}

                <div className="space desktop-shown" />
            </div>
        )}
        {pageName === foreignNationalProgramName && (
            <div xs={12} sm={10} className="style5 fs-1 mt-2">
                <h6 className="mb-0">
                    <ul>
                        <li>Fast, Accurate, and comes with our exclusive 100% trusted  warranty*</li>
                        <li>Max loan amount $2M</li>
                        <li>Min FICO 680 or Foreign Credit</li>
                        <li>Max DTI allowed 50%</li>
                        <li>Max LTV 75% for 680+ FICO / 70% for Foreign Credit</li>
                        <li>Interest-Only option available</li>
                        <li>Asset depletion option available</li>
                        <li>Second Home and Investment Occupancy</li>
                    </ul>
                </h6>
                {/* <p>*Visit <a href="https://www.swmc.com/disclaimer" target='_blank'>swmc.com/disclaimer</a> for terms and limitations of the 100% Trusted Warranty.</p> */}

                <div className="space desktop-shown" />
            </div>
        )}
        {pageName === fha203kProgramName && (
            <div xs={12} sm={10} className="style5 fs-1 mt-2">
                <h6 className="mb-0">
                    <ul>
                        <li>Fast, Accurate, and comes with our exclusive 100% trusted  warranty*</li>
                        <li>Minimum Credit Score 580</li>
                        <li>Owner-occupied Property</li>
                        <li>Manual Underwriting Allowed</li>
                        <li>Manufactured Homes Acceptable</li>
                        <li>Repair Limit:
                            <ul>
                                <li>Limited 203(K): $35,000</li>
                                <li>Standard 203(K): No limit</li>
                            </ul>
                        </li>
                        <li>Structural and Non-Structural Repairs Allowed</li>
                    </ul>
                </h6>
                {/* <p>*Visit <a href="https://www.swmc.com/disclaimer" target='_blank'>swmc.com/disclaimer</a> for terms and limitations of the 100% Trusted Warranty.</p> */}

                <div className="space desktop-shown" />
            </div>
        )}
    </>
}

const TitleContent = ({
    pageDetails
}) => {

    const { pageName } = pageDetails

    if (pageName === "Conventional") {
        return <>
            <h2 className={`fs-2dot5 ${pageName === "Conventional" ? 'conv-title' : ''
                }`}>
                {pageName} Home Loans
            </h2>
            <h3 className="show-desktop fsdesktoptext">
                <div>Instant Underwriting<sup>TM</sup>! <br />Loan file and condition review on demand! <br />Powered by AngelAi! <br />Fully Ai - Touchless Loan Production!</div>
            </h3>
        </>
    }
    if (pageName === "USDA") {
        return <>
            <h2 className="style0  fs-3 ">
                {pageName} Rural Home Loans
            </h2>
        </>
    }
    if (pageName === "Non QM") {
        return <>
            <h2 className="pt-1 fs-3 nonqmtext">
                Non-QM Loans
            </h2>
        </>
    }
    if (pageName === "Prime Jumbo") {
        return <>
            <h2 className="fs-2dot5">
                <div className='lg-inline-block'>Non-Conforming</div> Jumbo Program
            </h2>
        </>
    }
    if (pageName === "DSCR") {
        return <>
            <h2 className="fs-2dot5 dscr-banner-title">
                Debt Service Coverage Ratio Program
            </h2>
            <h3 className="show-desktop fs-2">
                <div>8 AM LOAN APPROVALS!</div>
            </h3>
        </>
    }
    if (pageName === foreignNationalProgramName) {
        return <>
            <h2 className="fs-2dot5 fn-banner-title">
                Foreign National Program
            </h2>
            <h3 className="show-desktop fs-2">
                <div>8 AM LOAN APPROVALS!</div>
            </h3>
        </>
    }
    if (pageName === fha203kProgramName) {
        return <>
            <h2 className="fs-3 fh203k-banner-title">
                FHA 203(K) Loan Program
            </h2>
            <h3 className="show-desktop fsdesktoptext">
                {/* <div>Instant Underwriting<sup>TM</sup>! <br/>Loan file and condition review on demand! <br/>Powered by AngelAi! <br/>Fully Ai - Touchless Loan Production!</div> */}
            </h3>
        </>
    }

    return <h2 className="sm-pt-2-test fs-3">
        {pageName} Home Loans
    </h2>
}

const BannerSection = ({
    pageDetails
}) => {


    const [screen, setScreen] = useState(window.innerWidth > 575 ? 'desktop' : 'mobile')
    const [leftDivheight, setleftDivheight] = useState('200px')
    const [brokerFormDomValue, setbrokerFormDomValue] = useState(document.getElementsByClassName('broker-form-container') || document.getElementsByClassName('bnaeer-section'))
    const [stickerDimensions, setstickerDimensions] = useState([window.innerWidth > 575 ? 600 : 400, 200])
    const [isFormSubmitted, setIsFormSubmitted] = useState(false)

    const [isFHABrokerFormSubmitted, setIsFHABrokerFormSubmitted] = useState(false)
    const [isFHABrokerModal, setIsFHABrokerModal] = useState(false)

    const handleFHAModalOpen = () => {
        setIsFHABrokerModal(true)
    }

    const handleFHAModalClose = () => {
        setIsFHABrokerModal(false)
    }

    const isConventionalPage = pageDetails.pageName === 'Conventional'
    const isNonQM = pageDetails.pageName === 'Non QM'
    const isFHA = pageDetails.pageName === 'FHA'
    const isPrimeJumbo = pageDetails.pageName === 'Prime Jumbo'
    const isHECM = pageDetails.pageName === 'HECM'
    const isDscr = pageDetails.pageName === 'DSCR'
    const isForeignNational = pageDetails.pageName === 'Foreign National'
    const isFHA203K = pageDetails.pageName === fha203kProgramName
    const isErrInBrokerForm = useSelector((state) => state.nameReducer.errInBrokerForm);
    const dispatch = useDispatch();
    const userSession = new UserSession();

    const leftHeightSetter = () => {

        let screenFactor = 0.9

        if (window.innerWidth < 769 && window.innerWidth > 575) {
            screenFactor = 0.8
        }

        const infoBoxDiv = document.getElementsByClassName('info-box')
        const brokerFormDomValue = document.getElementsByClassName('broker-form-container')
        setbrokerFormDomValue(brokerFormDomValue)
        // setleftDivheight(`${Math.round((brokerFormDomValue[0].offsetHeight + brokerFormDomValue[0].offsetTop)*screenFactor)}px`)
        setleftDivheight(`${Math.round(infoBoxDiv[0].offsetHeight)}px`)

        computeStickerDimensions(infoBoxDiv, brokerFormDomValue)

    }

    const computeStickerDimensions = (infoBoxDiv, brokerFormDomValue) => {

        let stickerDimensionsRefPoint = infoBoxDiv

        let stickerHeight = brokerFormDomValue[0].offsetHeight - stickerDimensionsRefPoint[0].offsetHeight * 0.99
        let stickerWidth = Math.round((stickerDimensionsRefPoint[0].offsetWidth) * 0.9)
        // console.log('Sticker width: ',  stickerWidth )

        // if info div height > threshold for broker form height, dont show sticker 

        if (isPrimeJumbo &&
            window.innerWidth < 1200 && window.innerWidth > 769
        ) {
            if (stickerDimensionsRefPoint[0].offsetHeight < brokerFormDomValue[0].offsetHeight * 0.99) {
                const ele = document.getElementById("consent-desc-id")
                if (ele) {
                    stickerHeight = (ele.offsetHeight)
                    stickerWidth = Math.round((stickerDimensionsRefPoint[0].offsetWidth) * 0.8)
                }
            }
        }


        if ((window.innerWidth < 769) && (window.innerWidth > 575) && (screen === 'desktop')) {

            if (isFha) {
                /**WHL-94: marquee considered from FHA */
                const marq = document.getElementsByClassName('marquee')

                if (marq[0] && (marq.length === 1)) {
                    stickerHeight = stickerHeight - ((marq[0].offsetHeight) / 2)
                    setleftDivheight(state => {
                        return `${parseInt(state) + (marq[0].offsetHeight) / 2}px`
                    })
                }
            }

            if (stickerDimensionsRefPoint[0].offsetHeight > brokerFormDomValue[0].offsetHeight * 0.85) {
                stickerHeight = brokerFormDomValue[0].offsetHeight - stickerDimensionsRefPoint[0].offsetHeight * 0.96

                stickerWidth = Math.round((stickerDimensionsRefPoint[0].offsetWidth) * 0.8)
            }
        }

        if (window.innerWidth < 575) {
            // stickerDimensionsRefPoint as form blue title 

            stickerDimensionsRefPoint = document.getElementsByClassName('form-titles-section')

            if (stickerDimensionsRefPoint[0]) {
                stickerWidth = stickerDimensionsRefPoint[0].offsetWidth
                stickerHeight = stickerDimensionsRefPoint[0].offsetHeight
            }

        }

        setstickerDimensions([stickerWidth, stickerHeight])

    }

    const screenSetter = () => {
        window.innerWidth > 575 ? setScreen('desktop') : setScreen('mobile')
        dispatch(setDeviceType({
            deviceType: window.innerWidth > 575 ? 'desktop' : 'mobile',
            screenWidthXHeight: [window.innerWidth, window.innerHeight]
        }))
        leftHeightSetter()
    }

    useEffect(() => {

        /**
         * Observer should properly handle loading of content and track that much content height
         */

        const observer = new ResizeObserver(entries => {
            for (const entry of entries) {
                window.addEventListener('resize', screenSetter);
                leftHeightSetter()
            }
        })
        observer.observe(document.querySelectorAll('.info-box.container')[0])

        /** WHL-57: localstorage has FULL DOCS REFI as default in case of Non QM,
        so to ovveride it , resetting it here*/
        if (isNonQM ||
            isPrimeJumbo ||
            isDscr ||
            isForeignNational
        ) {
            userSession.setLoanPurpose('')
            userSession.setLoanPurposeKeyword('PURCHASE')
        }

        return () => {
            window.removeEventListener('resize', screenSetter);
        }

    }, [])

    const isFormSubmitSuccess = (flag) => {
        setIsFormSubmitted(flag)
    }

    const isFHABrokerFormSubmitSuccess = (flag) => {
        setIsFHABrokerFormSubmitted(flag)
    }

    const fhaModalCloseCallback = (flag) => {
        setIsFHABrokerModal(flag)

    }

    return (
        <>
            <div className={"banner-section desktop-shown " +
                // conv-pgm-banner-height added for other pages as well for common margin-bottom
                `${isConventionalPage || isNonQM || isDscr || isForeignNational || isHECM || isFHA203K ?
                    'conv-pgm-banner-height ' : ' '
                }` +
                `${isPrimeJumbo ? 'prime-jumbo-banner-height ' : ' '}` +
                `${isHECM ? 'hecm-banner-height hecmBannerMarginTop' : ''}` +
                `${isNonQM ? 'nonqm-banner-height' : ''}` +
                `${isDscr ? 'dscr-banner-height' : ' '}` +
                `${isFHA203K ? 'dscr-banner-height fha203k-banner-height ' : ' '}` +
                `${isFormSubmitted ? 'ack-form-present' : ''}`
                // +
                // `${isErrInBrokerForm ? ' error-shownl' : ''}`
            }>

<div className="mobile-AccessibilityMenu-show">
                <UserWayAccessibilityMenu color="white" width={50} height={50} />
                </div> 

                <div className={"banner-background " + `${isFHA ? 'fhaBackground' : ''}`} ></div>
                <Container className={
                    `banner-content-container ${isNonQM ? ' nonqm-custom-width-container' : ''
                    }`
                }>
                    {/* WHL-84  */}
                    <Row>
                        {isFHA && <FhaOnlyMarquee onClick={handleFHAModalOpen} />
                        }
                    </Row>



                    <Row className="justify-content-space-between">

                        <Col sm={6} md={6} lg={7} className="info pl-0 pr-0">
                            <Row className="m-0">
                                <Container className={"info-box " +
                                    `${isConventionalPage ? 'conv-pgm-p-top ' : ' '}` +
                                    `${isPrimeJumbo ? 'prime-jumbo-p-top ' : ' '}`
                                }>
                                    <div className="">
                                        <TitleContent pageDetails={pageDetails} />
                                    </div>
                                    <div className="form-mobile-entry">
                                    </div>
                                    <div className="desktop-shown ">
                                        <SectionBelowTitle pageDetails={pageDetails} screen={screen} />
                                    </div>

                                    {/* Sticker should be shown when min height is maintained */}

                                    <div className="alert-patch-below-banner">


                                        {/* <PopupPatch
                                message='Fast 100% Trusted Ai<br/>  Underwriting*'
                                stickerDimensions={stickerDimensions}
                            /> */}
                                    </div>


                                </Container>
                            </Row>
                        </Col>
                        <Col lg={5} md={6} sm={6} className={
                            `form-desktop-entry pl-0` +
                            `${isFormSubmitted ? ' ack-form-present' : ''}`
                        } style={{
                            display: screen === 'desktop' ? 'block' : 'none' // WHL-32 : to solve double frmContact id issue
                        }}>
                            {
                                screen === 'desktop' &&
                                (
                                    isFormSubmitted ?
                                        <FormAcknowledgement isFormSubmitSuccess={isFormSubmitSuccess} />
                                        :
                                        <BrokerForm
                                            screen={screen}
                                            pageDetails={pageDetails}
                                            isFormSubmitSuccess={isFormSubmitSuccess}
                                        />
                                )
                            }
                        </Col>

                        {isNonQM && (
                            <>
                                <p className='nonqmdisclaimer-banner'>
                                    *Visit{" "}
                                    <a href="https://www.swmc.com/disclaimer" target="_blank" style={{ color: "#fff" }}>
                                        swmc.com/disclaimer
                                    </a>{" "}
                                    for terms and limitations of the 100% Trusted Warranty.
                                </p>
                                <p className='nonqmdisclaimer-banner'>
                                    **For EZ DSCR (Debt Service Credit Ratio) Program, 2<sup>nd</sup>{" "}
                                    full appraisal is required if Collateral Desktop Analysis (CDA)
                                    variance is {">"} 10%, and for Individual Tax Identification
                                    Number (ITIN) program 2<sup>nd</sup> appraisal required in case of
                                    Flip transaction.
                                </p>
                            </>
                        )}

                    </Row>
                </Container>
            </div >
            <div className="desktop-testimonial">
                <TestimonialCarousel />
            </div>
            {screen === 'mobile' && <>
                <div className="mobile-shown">

                    {/* WHL-84  */}

                    {isFHA && <Row>
                        <FhaOnlyMarquee onClick={handleFHAModalOpen} />
                    </Row>
                    }
<div className="mobile-AccessibilityMenu-show">
      <UserWayAccessibilityMenu color="white" width={40} height={40} />
    </div>

                    <div className="mobile-bg-banner">
                        <div className="banner_image banner-mobile-title">
                            <TitleContent pageDetails={pageDetails} />

                            {isFHA &&
                                <p onClick={handleFHAModalOpen} className="mobileOnlyFhaSubHeader">SUN WEST NOW OFFERS A 0% OPTION</p>}

                        </div>
                        <div className="desktop-mobile">
                            <TestimonialCarousel />
                        </div>
                        {screen === 'mobile' && <div className="alert-patch-below-banner">
                            {/* <PopupPatch
                                            message='Fast 100% Trusted Ai<br/>  Underwriting*'
                                            stickerDimensions={stickerDimensions}
                                        /> */}
                        </div>}
                        <div className="ps_sticked">
                            {
                                isFormSubmitted ?
                                    <FormAcknowledgement isFormSubmitSuccess={isFormSubmitSuccess} /> :
                                    <BrokerForm
                                        screen={screen}
                                        pageDetails={pageDetails}
                                        isFormSubmitSuccess={isFormSubmitSuccess}
                                    />
                            }
                            <div className="pt-4 bg-white max-width-90vw noOverlayWrap">
                                {
                                    (
                                        pageDetails.pageName === "Conventional" ||
                                        pageDetails.pageName === "DSCR" ||
                                        pageDetails.pageName === foreignNationalProgramName
                                    ) &&
                                    <h3 className="show-mobile">
                                        <div>Instant Underwriting<sup>TM</sup>! <br />Loan file and condition review on demand! <br />Powered by AngelAi! <br />Fully Ai - Touchless Loan Production!</div>
                                    </h3>
                                }
                                <Container fluid="sm">
                                    <SectionBelowTitle pageDetails={pageDetails} screen={screen} />
                                    {isNonQM && (
                                        <>
                                            <div className="nonqmdisclaimer-mobile">
                                                <p className='nonqmdisclaimer-banner'>
                                                    *Visit{" "}
                                                    <a href="https://www.swmc.com/disclaimer" target="_blank" style={{ color: "#1e4383" }}>
                                                        swmc.com/disclaimer
                                                    </a>{" "}
                                                    for terms and limitations of the 100% Trusted Warranty.
                                                </p>
                                                <p className='nonqmdisclaimer-banner'>
                                                    **For EZ DSCR (Debt Service Credit Ratio) Program, 2<sup>nd</sup>{" "}
                                                    full appraisal is required if Collateral Desktop Analysis (CDA)
                                                    variance is {">"} 10%, and for Individual Tax Identification
                                                    Number (ITIN) program 2<sup>nd</sup> appraisal required in case of
                                                    Flip transaction.
                                                </p>
                                            </div>
                                        </>
                                    )}
                                </Container>
                            </div>
                        </div>
                    </div>
                </div>
            </>}

            <Modal show={isFHABrokerModal}
                size="md"
                onHide={handleFHAModalClose}
                className="fhaModal">

                <Modal.Header closeButton className="fhaModal-header"></Modal.Header>

                {isFHABrokerFormSubmitted ?
                    <FhaFormAcknowledgement isFormSubmitSuccess={isFHABrokerFormSubmitSuccess} />
                    :
                    <FHABrokerForm
                        isFormSubmitSuccess={isFHABrokerFormSubmitSuccess}
                        handleFhaModalClose={fhaModalCloseCallback}
                    />
                }

            </Modal>
        </>
    );
}

export default BannerSection;